/* Index_object_real_results_marquee */
initMarquee('.Index_object_real_results_marquee', {
    mobile: {
        duration: 50000,
        gap: 0,
        duplicated: true,
        direction: "left",
        //pauseOnHover: true
    },
    desktop: {
        duration: 80000,
        gap: 0,
        duplicated: true,
        direction: "left",
        //pauseOnHover: true
    }
});


const playlist = document.querySelector(".video_play_list");

/* Coverflow's stretch was a hard coded 172px, which is about the side gutter at
   the width it was tuned on. On a phone that same 172px drags each neighbouring
   slide roughly 170px on top of the active card, so a strip of clipped
   neighbour text shows down both edges. The gutter changes with the viewport,
   so the pull has to be measured rather than hard coded: park the neighbours
   just past the edge at whatever width the phone actually is. */
function rrFitCoverflow(sw) {

  if (!sw || !sw.el || !sw.slides || !sw.slides.length) return;

  const trackWidth = sw.el.clientWidth;

  /* Zero width means the container is display:none. This slider sits inside
     Mobile_only_new, so that is every desktop viewport. Leave it alone. */
  if (!trackWidth) return;

  const slideWidth = sw.slides[0].offsetWidth;
  if (!slideWidth) return;

  /* depth is 0 on purpose. Any translateZ puts the neighbours in 3D, so
     perspective scales the horizontal shift to about 0.9 of its value and the
     arithmetic below stops being exact. Flat keeps it 1:1. */
  const gutter  = (trackWidth - slideWidth) / 2;
  const stretch = -(gutter + 8);   /* 8px clearance so rounding cannot leak a sliver */

  if (sw.params.coverflowEffect.stretch === stretch) return;

  sw.params.coverflowEffect.stretch = stretch;
  sw.update();

}


/* One gesture has to land exactly one slide. Swiper's short swipe branch adds a
   whole slide on top of whichever slide the finger had already dragged the track
   into, so a flick that carries the track a full slide step and finishes inside
   longSwipesMs arrives two slides on. A step here is the 300px card, and a 300px
   flick is an ordinary thumb on a 390px phone, so it happened constantly.
   Swiper emits touchEnd before it works out where to snap, so capping the
   release position to just under one step leaves its own arithmetic to add the
   single slide. Anything shorter than a step is left alone and feels the same. */
function rrCapSwipeToOneSlide(sw) {

  if (!sw || !sw.touchEventsData || !sw.slidesSizesGrid) return;

  /* Free mode hands the release off to its own momentum path before the snap
     arithmetic runs, so there is nothing there to cap. */
  if (sw.params.freeMode && sw.params.freeMode.enabled) return;

  const start = sw.touchEventsData.startTranslate;
  if (typeof start !== 'number') return;

  const slideWidth = sw.slidesSizesGrid[sw.activeIndex];
  const gap = parseFloat(sw.params.spaceBetween) || 0;
  const step = slideWidth ? slideWidth + gap : 0;
  if (!step) return;

  /* Just under a whole step. Landing exactly on the boundary would read as the
     next slide and the increment would stack on top of that instead. */
  const cap = step * 0.9;
  const moved = sw.translate - start;
  if (Math.abs(moved) <= cap) return;

  const capped = start + (moved < 0 ? -cap : cap);
  sw.translate = capped;
  sw.touchEventsData.currentTranslate = capped;

}


/* SWIPER */
document.querySelectorAll('.Index_object_real_results_slider').forEach(el => {
  if (!el.classList.contains('swiper-initialized')) {
    new Swiper(el, {
      /* The neighbouring slides now sit fully off screen, so their lazy media no
         longer trips the browser's in-viewport check and would otherwise only
         start loading once the swipe had begun. Preload the two either side. */
      lazyPreloadPrevNext: 2,
      loop: true,
      grabCursor: true,
      spaceBetween: 0,
      slidesPerGroup: 1,
      slidesPerView: "auto",
      watchSlidesProgress: true,
      draggable: true,
      autoHeight: false,
      watchOverflow: true,
      threshold: 10,

      mousewheel: {
        forceToAxis: true
      },

      effect: "coverflow",
      centeredSlides: true,

      coverflowEffect: {
        rotate: 0,
        stretch: 0,
        depth: 0,
        modifier: 1,
        slideShadows: false
      },

      observer: true,
      observeParents: true,

      /* Scoped to this slider, same reason as the product media gallery: a bare
         ".swiper-pagination" selector matches document-wide and grabs the first
         one in the DOM rather than its own. */
      pagination: {
        el: el.querySelector(".swiper-pagination"),
        clickable: true
      },

      /* Autoplay removed. This advanced itself every 10s, which reads as the
         page moving under you. Advancing is now drag, arrow or dot only. */

      on: {
        init: function () {
          rrFitCoverflow(this);
        },
        resize: function () {
          rrFitCoverflow(this);
        },
        touchEnd: function () {
          rrCapSwipeToOneSlide(this);
        },
        slideChange: function () {
          muteAllVideos();
        }
      }
    })
  }
});


/* MUTE ALL */
function muteAllVideos() {

  if (!playlist) return;

  playlist.querySelectorAll(".full_video_new").forEach(function (item) {

    const video     = item.querySelector('video');
    const muteBtn   = item.querySelector('.mute_video');
    const unmuteBtn = item.querySelector('.unmute_video');

    if (!video || !muteBtn || !unmuteBtn) return;   // null guard

    video.muted = true;
    muteBtn.classList.remove('active');
    unmuteBtn.classList.add('active');

  });

}


/* VIDEO BUTTON CONTROLS (EVENT DELEGATION) */

if (playlist) {

  playlist.addEventListener("click", function (e) {

    const muteBtn = e.target.closest(".mute_video");
    const unmuteBtn = e.target.closest(".unmute_video");

    if (!muteBtn && !unmuteBtn) return;

    const parent = e.target.closest(".full_video_new");
    const video = parent.querySelector("video");
    const mute = parent.querySelector(".mute_video");
    const unmute = parent.querySelector(".unmute_video");

    /* MUTE BUTTON */
    if (muteBtn) {

      video.muted = true;

      mute.classList.remove("active");
      unmute.classList.add("active");

    }

    /* UNMUTE BUTTON */
    if (unmuteBtn) {

      const wasPlaying = !video.paused;

      /* MUTE OTHER VIDEOS ONLY */
      playlist.querySelectorAll("video").forEach(function (v) {
        if (v !== video) v.muted = true;
      });

      playlist.querySelectorAll(".full_video_new").forEach(function (item) {

        if (item !== parent) {

          item.querySelector(".mute_video").classList.remove("active");
          item.querySelector(".unmute_video").classList.add("active");

        }

      });

      video.muted = false;

      unmute.classList.remove("active");
      mute.classList.add("active");

      /* SAFARI STABILITY FIX */
      if (wasPlaying) video.play();

    }

  });

}


/* Video List End */